import React from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import styles from "./Employee.styles";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const ReactHTMLPicture = loadable(() =>
	import("@micado-digital/react-htmlpicture/ReactHTMLPicture")
);

const Employee = ({ media, name, mail }) => {
	const { REACT_APP_PATH } = process.env;
	const css = styles();

	return (
		<Box className={clsx(css.root, "extension-employee")}>
			<div className={css.image}>
				<ReactHTMLPicture
					alt={name}
					media={media}
					path={REACT_APP_PATH}
					xs="extension-team"
					webpFallback={true}
				/>
			</div>
			<div className={css.content}>
				{name && (
					<Typography
						className={css.name}
						color="textPrimary"
						dangerouslySetInnerHTML={{ __html: name }}
						variant="subtitle1"
						component="p"
					/>
				)}
				{mail && (
					<Typography className={css.mail} variant="subtitle1" component="div">
						<a href={"mailto:" + mail}>
							<ReactSVGIcon src="/img/icons/mail-outlined.svg" size={16} />
							<span>{mail}</span>
						</a>
					</Typography>
				)}
			</div>
		</Box>
	);
};

export default Employee;
